export function trimDescription(description: string) {
  return description?.trim();
}

